module.exports = __webpack_public_path__ + "img/promote.3b4a72f2.svg";